var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"dark-mode-toggle",on:{"click":_vm.toggleDarkMode}},[(_vm.theme === 'dark')?_c('span',[_vm._v("🌙")]):_c('span',[_vm._v("☀️")]),_vm._v(" "+_vm._s(_vm.theme === 'dark' ? _vm.$t('深色') : _vm.$t('浅色'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }